import { getStaticAssetComponents } from './get-static-asset-components.js'
export function getStaticCustomComponents(): string[] {
  return getStaticAssetComponents('custom')
}
